// extracted by mini-css-extract-plugin
export default {"builder-layout":"BuilderLayout_builder-layout__8GYiE","bg-stain-top":"BuilderLayout_bg-stain-top__D2U3S","bg-stain-bottom":"BuilderLayout_bg-stain-bottom__cE1KA"};